import React, {useEffect, useState} from 'react'

import SessionStore from "../../../services/session/SessionStore";
import {Confirm, Pagination} from "../../../components";
import {ToastService} from "../../../components/toasts/Toasts";
import UncontrolledTooltip from "reactstrap/lib/UncontrolledTooltip";
import TemplateEditor from "./TemplateEditor";
import {
    createLocalPagesTemplate,
    deleteLocalPagesTemplate,
    localPagesContents,
    loadLocalPagesTemplates, 
    localPagesBrands,
    downloadTemplateJson,
    uploadTemplateJson, contentsCount,
} from "../manageLocations/localPages/LocalPagesApi";
import presignedExport from "../../../services/auth/presignedExport";
import {navigatePathAndQuery} from "../../../util/UrlFragmentSearch";
import RegionCard from "../../../components/cards/RegionCard";
import RegionCardBody from "../../../components/cards/RegionCardBody";
import Button from "../../../components/buttons/Button";
import PageCommands from "../../app/layout/PageCommands";
import FileUploadButton from "../../../components/buttons/FileUploadButton";

export default function ManageTemplatesList({}) {
    const accountId = SessionStore.account.accountId;
    const [localPagesTemplateList, setLocalPagesTemplateList] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [selected, setSelected] = useState(null)
    const [confirmationModal, toggleConfirmation] = useState();
    const [brands, setBrands] = useState([])
    const [createMode, setCreateMode] = useState(false)
    const [usageMap, setUsageMap] = useState(new Map())

    const totalPages = 1;
    const currentPage = 1;

    const actions = [
        {
            onClick: (lpTemplate) => editTemplate(lpTemplate),
            show: () => (true),
            tooltip: (lpTemplate) => "Edit",
            iconClass: "fa fa-pencil fa-2x control-spacer-right",
        },
        {
            onClick: (lpTemplate) => copyTemplate(lpTemplate),
            show: () => (true),
            tooltip: (lpTemplate) => "Duplicate",
            iconClass: "fa fa-clone fa-2x control-spacer-left control-spacer-right",
        },
        {
            onClick: (lpTemplate) => {
                toggleConfirmation(() => (
                    <Confirm
                        visible={true}
                        onContinue={() => {
                            // group.id is an id that was added to normalize the publishing dropdown.
                            // If you want the ObjectId, use group.publishingGroupId.
                            deleteTemplate(lpTemplate)
                        }}
                        toggle={() => toggleConfirmation(() => undefined)}
                        header={`Remove ${lpTemplate.templateName}?`}
                        message="This will delete the template permanently. It cannot be undone."
                        confirmText="Remove Template"
                    />
                ));
            },
            show: () => (true),
            tooltip: (lpTemplate) => "Delete",
            iconClass: "fas fa-trash-alt fa-2x control-spacer-left control-spacer-right",
        },
        {
            onClick: (lpTemplate) => downloadTemplate(lpTemplate),
            show: () => (true),
            tooltip: (lpTemplate) => "Download",
            iconClass: "fa fa-cloud-download fa-2x control-spacer-left control-spacer-right",
        },
        {
            onClick: (lpTemplate) => downloadTemplateJson(lpTemplate._id),
            show: () => (true),
            tooltip: (lpTemplate) => "Export",
            iconClass: "fas fa-download fa-2x control-spacer-left control-spacer-right",
        }
    ]



    const reactActions = (lpTemplate) => {

        return (<div className="btn-group">
            {actions.map((action, index) => {
                const id = 'actions-' + index + "-" + lpTemplate._id;
                return (<div className={"btn btn-sm"} key={"div1" + id}>
                        <span id={id} key={id} className={action.iconClass} onClick={() => action.onClick(lpTemplate)}/>
                        <UncontrolledTooltip placement="top"
                                             target={id}>{action.tooltip(lpTemplate)}</UncontrolledTooltip>
                    </div>
                )
            })}
        </div>)
    }

    const getBrandsForTemplate = (myTemplate) => {
       return brands.filter(brand => myTemplate.brandIds.includes(brand.vendorId))
    }

    const countClicked = (template, mouseEvent) => {
        mouseEvent.preventDefault()
        navigatePathAndQuery("/listings/localPagesReport", {templates:template._id});
    }

    const getColumns = () => ([
        {id: 'template', title: 'Template', get: (item) => item.templateName},
        {id: 'business', title: 'Business', get: (item, index) => getBrandsForTemplate(item).map(brand=>brand.name).join()},
        {id: 'dateAdded', title: 'Date Added', get: (item) => new Date(item.dateAdded.$date).toLocaleDateString()},
        {
            id: 'lastUpdated',
            title: 'Last Updated',
            get: (item) => new Date(item.modifiedDate.$date).toLocaleDateString("en-US")
        },
        {id: 'locations', title: 'Locations', get: (item) => <a href="" tabIndex={0} onClick={(mouseEvent) => countClicked(item, mouseEvent)}>{usageMap.get(item._id)}</a>},
        {id: 'actions', title: 'Actions', get: (item) => reactActions(item)}
    ])

    const editTemplate = (lpTemplate) => {
        setSelected(lpTemplate)
    }

    const deleteTemplate = async (localPagesTemplate) => {
        const resp = await deleteLocalPagesTemplate(localPagesTemplate)
        if (resp.status == 204) { //deleted successfully
            const indexToDelete = localPagesTemplateList.findIndex(template => (localPagesTemplate._id === template._id))
            localPagesTemplateList.splice(indexToDelete, 1)
            setLocalPagesTemplateList([...localPagesTemplateList])
        }
    }

    const loadTemplateList = () => {
        loadLocalPagesTemplates(0, 100, accountId).then(data => {
            setLocalPagesTemplateList(data)
            const vendorIds = data.flatMap(template => template.brandIds)
            loadBrands(vendorIds)
            loadContentsCount(data.map(template => template._id))
        })
    }


    const loadBrands = (vendorIds) => {
        localPagesBrands({offset: 0, limit: 100, accountIds: [accountId], vendorIds}).then(data => {
            setBrands(data)
            setIsLoading(false)
        })
    }

    const loadContentsCount = (templateIds) => {
        contentsCount(templateIds).then(map => {
            //map contains an object whose property names are template ids
            // and values are number of documents tied to that template id
            setUsageMap(new Map(Object.entries(map)))
        })

    }


    useEffect(() => {
        loadTemplateList()
    }, []) // pass in an empty array means "this function has no dependencies, just run it the one time". Otherwise when dependencies change between renders, the function will be called again


    const createNewTemplate = () => {
        createLocalPagesTemplate("New Template", [], "DevHub").then(resp => {
            const newTemplate = resp
            localPagesTemplateList.push(newTemplate)
            setCreateMode(true)
            setSelected(newTemplate)
        })
    }

    const copyTemplate = (lpTemplate) => {

        createLocalPagesTemplate("copy of " + lpTemplate.templateName, lpTemplate.brandIds, "DevHub", lpTemplate.sections).then(resp => {
            if (resp.status == 200) { //created successfully
                const newTemplate = resp.data
                const newTemplateList = localPagesTemplateList.push(newTemplate)
                setSelected(newTemplate)
            } else {
                //to do put error handling here
                console.log("Error copying template")
                console.log("response is ", resp)
            }
        })
    }

    const downloadTemplate = (lpTemplate) => {
        return presignedExport.downloadExport(`/v5/localPages/localPagesUploaderExport/${lpTemplate._id}`);
    }

    const doneEditing = () => {
        setSelected(null)
        setIsLoading(true)
        setCreateMode(false)
        loadTemplateList()
    }

    const columns = getColumns()

    const handleUploadedTemplateJson = event => {
        const file = event.target.files[0]
        const formData = new FormData();
        formData.append(
          "newTemplate",
          file,
          file.name
        );

        uploadTemplateJson(formData)
          .then(loadTemplateList)
          .catch(err => {
              if (err.response.status === 400 && err.response.data.includes("already exists in another account")) {
                  ToastService.error(
                    "Unable to Import Template",
                    "Failed to import template because one with the same ID exists in another account." +
                        " Either re-upload to the same account, or remove the template ID from the upload to import a fresh copy."
                  );
              } else throw err
          })
    };

    return (<div>
              <PageCommands>
                  <Button icon={"far fa-plus"} onClick={createNewTemplate}>Create</Button>
                  <FileUploadButton handleFileUpload={handleUploadedTemplateJson} className="control-spacer-left">Upload</FileUploadButton>
              </PageCommands>
            {confirmationModal}
            <div>
                {isLoading &&
                <div className="text-center">
                    <h4 className="admin-update-status">Loading</h4><i className="fa fa-spinner fa-spin fa-2x"></i>
                </div>
                }
                {(!isLoading && !selected) &&
                <RegionCard>
                    <RegionCardBody className="card-only-child">
                        <div className="table-responsive">
                            <table className="table table-striped table-hover table-borderless mb-0">
                                <thead>
                                <tr key="headerRow-key" className="">
                                    {columns.map(column => <th key={'column-title-' + column.title}>
                                        <span>{column.title} {}</span></th>)}
                                </tr>
                                </thead>
                                <tbody>
                                {localPagesTemplateList.map((template, index) => <tr
                                    key={"dataRow-key" + index}>{columns.map(column => <td
                                    key={'column-data-' + column.title + index}><span>{column.get(template)}</span>
                                </td>)}</tr>)}
                                </tbody>
                            </table>
                        </div>

                        <div className="card-footer">
                            <Pagination
                                className="d-flex justify-content-center"
                                totalPages={totalPages}
                                currentPage={currentPage}
                                onChange={(pageNumber) => {
                                    console.log("pageNumber is ", pageNumber)
                                }}
                            />
                        </div>

                    </RegionCardBody>
                </RegionCard>

                }
            </div>

            {selected && <TemplateEditor
                localPagesTemplate={selected}
                doneEditingFunction={doneEditing}
                brandsForTemplate={getBrandsForTemplate(selected)}
                brandsForAccount={brands}
                createMode={createMode}
                deleteFunction={deleteTemplate}
            />}

            {/*{selected && <ContentEditor localPagesTemplate={selected} singleLocationMode={false}/>}*/}

        </div>
    )

}
